const productMenuInit = (menu: HTMLElement) => {
  const productsMenus: NodeListOf<HTMLElement> = document.querySelectorAll('.products-menu');
  const togglers: NodeListOf<HTMLElement> = document.querySelectorAll('.menu-toggler a'); // make sure to add class to listitem in appearance menu with the following "menu-toggler menu__item--has-children"
  const closers: NodeListOf<HTMLElement> = document.querySelectorAll('.products-menu__close');
  const categoryLinks: NodeListOf<HTMLElement> = menu?.querySelectorAll('.products-menu__category-link');
  const categorySubLinks: NodeListOf<HTMLElement> = menu?.querySelectorAll('.products-menu__sub-category-link');
  const productsLinks: NodeListOf<HTMLElement> = menu?.querySelectorAll('.products-menu__products-link');
  const productsMenu: HTMLElement = document.querySelector('.products-menu');

  let browserActionHover = 'mouseenter';

  let menuHoverStatus = false;
  let hoverTimer;

  const toggleMenu = () => {
    if (menuHoverStatus === false) {
      menu?.classList.remove('products-menu--active');
    } else {
      menu?.classList.add('products-menu--active');
    }
    clearInterval(hoverTimer);
  };

  function isSmallScreen(): boolean {
    return window.innerWidth < 767;
  }

  if (isSmallScreen()) {
    browserActionHover = 'click';
  } else {
    browserActionHover = 'mouseenter';
  }

  const showMenu = (e: Event) => {
    e.preventDefault();

    menuHoverStatus = true;
    toggleMenu();
  };

  const hideMenu = (e: Event) => {
    e.preventDefault();

    menuHoverStatus = false;
    hoverTimer = setInterval(toggleMenu, 300);
  };

  const closerMenu = () => {
    setTimeout(() => {
      productsMenu.classList.remove('products-menu--active');
    }, 300);
  };

  const toggleSubMenu = (e: Event) => {
    const target = e.currentTarget as HTMLElement;

    [...categoryLinks]?.forEach((link) => {
      link?.querySelector('ul')?.classList.remove('active');
    });

    target.querySelector('ul')?.classList.add('active');
  };

  const toggleDeepMenu = (e: Event) => {
    const target = e.currentTarget as HTMLElement;

    [...categorySubLinks]?.forEach((link) => {
      link?.querySelector('ul')?.classList.remove('active');
    });

    target.querySelector('ul')?.classList.add('active');
  };

  [...productsMenus, ...togglers]?.forEach(
    (toggler) => toggler.addEventListener(browserActionHover, showMenu),
  );

  [...productsMenus, ...togglers]?.forEach(
    (toggler) => toggler.addEventListener('mouseleave', hideMenu),
  );

  [...closers]?.forEach(
    (toggler) => toggler.addEventListener('click', closerMenu),
  );

  categoryLinks?.forEach((link) => link.addEventListener(browserActionHover, toggleSubMenu));
  categorySubLinks?.forEach((link) => link.addEventListener(browserActionHover, toggleDeepMenu));

  productsLinks.forEach((link: HTMLAnchorElement) => {
    link.addEventListener('click', () => {
      window.location.href = link.href;
    });
  });
};

export default productMenuInit;
